export const LegendColors = ['#008BD2', '#63D1B4', '#FFBF66', '#FE3123'];

export const formatedDataForTable = (pData: any[]) => {
    let array: any[] = [];
    pData.forEach((data: any, index: number) => {
        array.push({
          id: index,
          date: new Date(data.date).toLocaleString('fr-FR', {
            weekday: 'long',
            day: 'numeric',
            month: 'short',
          }),
          boonAndLister: data['boonlister'].value,
          canaSojourn: data['tscr'].value,
          prSojourn: data['tspr'].value,
          selfCleaning: data['tautocur'].value,
        });
    });
    return array;
};

export const formatedDataForGraphics = (pData: any[], pFilter: string) => {
    let array : any[] = [];
    pData.forEach((data: any, index: number) => {
        if (data[pFilter].value !== null) {
          array.push({
            id: index,
            x: new Date(data.date),
            y: data[pFilter].value,
            color: data[pFilter].colorLabel,
          });
        }
    });
    return array;
};

export const formatedDataForH2sDetailGraphics = (pData: any[], pTabsProps: any[]) => {
    let dataToReturn: any[] = [];
    pTabsProps.forEach((tab: any) => {
        const values = formatedDataForGraphics(pData, tab.filter);
        dataToReturn.push({ label: tab.label, data: values.length > 0 ? values : null });
    });
    return dataToReturn;
};

export const getBarColor = (pValue: any) => {
  switch (pValue.color) {
    case 'ROUGE':
      return '#FE3123';
    case 'ORANGE':
      return '#FFBF66';
    case 'VERT':
      return '#63D1B4';
    case 'BLEU':
      return '#008BD2';
    default:
      return 'black';
  }
};

export const switchDataLegendToShow = (
  pDataLegend: any,
  plabel: string,
  pUnit: string,
  pSymbole1: string,
  Symbole2: string
) => { 
  const legend: string[] = []; 

  if (pDataLegend !== null) {
    Object.entries(pDataLegend).forEach(([key, value]: [string, any]) => {
      if (key === plabel) {
        legend.push(
          `${pSymbole1} ${value[0]} ${pUnit}`,
          `entre ${value[0]} et ${value[1]} ${pUnit}`,
          `entre ${value[1]} et ${value[2]} ${pUnit}`,
          `${Symbole2} ${value[2]} ${pUnit}`
        );
      }
    });
  }
  
  return legend;  
};
